import 'altcha';

(() => {
	document.addEventListener('DOMContentLoaded', () => {
		requestAnimationFrame(() => {
			if ('ALTCHA_WIDGET_ATTRS' in window && typeof window['ALTCHA_WIDGET_ATTRS'] === 'object') {
				[...document.querySelectorAll('altcha-widget')].forEach((el) => {
					if (typeof el['configure'] === 'function' && !el.getAttribute('challengeurl')) {
						el.configure(window['ALTCHA_WIDGET_ATTRS']);
					}

					el.addEventListener('statechange', (ev) => {
						const form = el.closest('form');
						const altchaHidden = form ? form.querySelector('input[name="altcha-hidden"]') : null;
						if (ev.detail.state === 'verified' && altchaHidden) {
							altchaHidden.checked = true;
							altchaHidden.classList.remove('is-invalid');
						}
					});
				});
			}
		});
	});
})();
